<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ handleSubmit }"
  >
    <b-modal
      v-model="modal.show"
      :title="modalTitle"
      ok-title="Submit"
      size="lg"
      @ok.prevent="handleSubmit(onSubmit, isEntityFieldValid = !!entity)"
      @hidden="onHideModal"
      @show="onShowModal"
    >
      <template>
        <validation-provider
          v-slot="{errors, touched, validated, valid}"
          :bails=" false"
          rules="required"
          name="Sheet name"
        >
          <b-form-group label="Sheet Name">
            <b-form-input
              v-model="sheetName"
              :state="(!touched && !validated) ? null : valid ? null : false"
              placeholder="Sheet name"
            />
          </b-form-group>
          <span
            v-if="errors"
            class="error__message"
          >
            {{ errors[0] }}
          </span>
        </validation-provider>

        <entities-multiselect
          :is-entity-guid-valid="isEntityFieldValid"
          :is-edit-mode="isEditMode"
          @get-value-on-select="getValueOnSelect"
        />

        <b-form-group
          rules="required"
          label="File Name Column"
        >
          <b-form-input
            v-model="fileNameColumn"
            placeholder="Column name"
          />
        </b-form-group>

        <b-form-group
          rules="required"
          label="Start Column"
        >
          <b-form-input
            v-model="startColumn"
            type="number"
          />
        </b-form-group>

        <b-form-group
          rules="required"
          label="Start Row"
          type="number"
        >
          <b-form-input
            v-model="startRow"
            type="number"
          />
        </b-form-group>
        <div class="checkbox__wrapper">
          <b-form-checkbox
            id="useColumnPhysicalNames"
            v-model="useColumnPhysicalNames"
          />
          <label for="useColumnPhysicalNames">
            Use Column Physical Names
          </label>
        </div>
      </template>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import InputWidget from '../../../../core/components/complex-table/components/InputWidget';
import ContentSpinner from '../../../../core/components/ContentSpinner';
import EntitiesMultiselect
  from '@/modules/FileManipulationController/BatchList/components/AddEditBatchModalParts/EntitiesMultiselect.vue';
import {editSheetConfigItem, hideAddEditSheetConfigModal} from '@/store/modules/file-manipulation-controller/actions';
import {uuid} from 'vue-uuid';

const {
  mapState: mapStateDataManagement,
} = createNamespacedHelpers('dataManagement');
const {
  mapState,
  mapActions,
} = createNamespacedHelpers('fileManipulationController');
const {
  mapState: sidebarMapState,
} = createNamespacedHelpers('sidebar');

export default {
  name: 'AddEditSheetConfigModal',
  components: {
    EntitiesMultiselect,
    ContentSpinner,
    InputWidget,
  },
  data() {
    return {
      isEntityFieldValid: true,
      sheetName: '',
      localGuid: null,
      entity: null,
      fileNameColumn: '',
      useColumnPhysicalNames: true,
      startColumn: 0,
      startRow: 0,
    };
  },
  watch: {
    entity: {
      handler(val) {
        if(val && val.value && !this.isEntityFieldValid) {
          this.isEntityFieldValid = true;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      modal: state => state.addEditSheetConfigModal,
    }),
    ...mapStateDataManagement({
      entityList: state => state.tables.data,
    }),
    ...sidebarMapState({
      tablesList: state => state.tablesList,
    }),
    modalTitle() {
      return this.isEditMode ? 'Edit Sheet Config' : 'Add Sheet Config';
    },
    isEditMode() {
      return this.modal.data.sheetConfig;
    },
  },
  methods: {
    ...mapActions([
      'upsertBatch',
      'hideAddEditModal',
      'addItemToSheetConfig',
      'hideAddEditSheetConfigModal',
      'editSheetConfigItem',
    ]),
    async onSubmit() {
      if (!this.entity) {
        return;
      }
      if (!await this.$refs.observer.validate()) {
        return;
      }
      if (this.isEditMode) {
        this.editSheetConfigItem({
          sheetName: this.sheetName,
          entityGuid: this.entity.value,
          useColumnPhysicalNames: this.useColumnPhysicalNames,
          localGuid: this.localGuid,
          fileNameColumn: this.fileNameColumn,
          startRow: this.startRow,
          startColumn: this.startColumn,
        });
      } else {
        this.addItemToSheetConfig({
          sheetName: this.sheetName,
          localGuid: uuid.v4(),
          entity: this.entity,
          useColumnPhysicalNames: this.useColumnPhysicalNames,
          fileNameColumn: this.fileNameColumn,
          startRow: this.startRow,
          startColumn: this.startColumn,
        });
      }
      this.hideAddEditSheetConfigModal();
    },
    onShowModal() {
      if (this.isEditMode) {
        this.fileNameColumn = this.modal.data.currentEntry.fileNameColumn;
        this.sheetName = this.modal.data.currentEntry.sheetName;
        this.useColumnPhysicalNames = this.modal.data.currentEntry.useColumnPhysicalNames;
        this.startRow = this.modal.data.currentEntry.startRow;
        this.startColumn = this.modal.data.currentEntry.startColumn;
        this.entity = this.modal.data.currentEntry.entityGuid;
        this.localGuid = this.modal.data.currentEntry.localGuid;
      }
    },
    getValueOnSelect(val) {
      this.entity = val;
    },
    onHideModal() {
      this.resetForm();
    },
    resetForm() {
      this.sheetName = '';
      this.entity = '';
      this.useColumnPhysicalNames = true;
      this.fileNameColumn = '';
      this.startColumn = 0;
      this.startRow = 0;
    },
  },
};
</script>

<style scoped>
.checkbox__wrapper {
  display: flex;
  align-items: center;

  label {
    margin-bottom: 0;
  }
}

.error__message {
  position: absolute;
  transform: translateY(-100%);
}
</style>